"use client";

import { useEffect } from "react";
import useStore from "../lib/Store/useStore";

export default function DatadogInit() {
    const { userData } = useStore();

    useEffect(() => {
        // Only run in production and on client
        if (typeof window === "undefined" || process.env.NEXT_PUBLIC_ENV !== "production") return;

        const setupDatadog = async () => {
            const { datadogRum } = await import("@datadog/browser-rum");
            const { datadogLogs } = await import("@datadog/browser-logs");

            datadogRum.init({
                applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID,
                clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
                site: "us5.datadoghq.com",
                forwardErrorsToLogs: true,
                service: "box-website",
                env: "production",
                sessionSampleRate: 100,
                sessionReplaySampleRate: 80,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: "mask-user-input",
            });

            datadogLogs.init({
                clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
                site: "us5.datadoghq.com",
                forwardErrorsToLogs: true,
                forwardConsoleLogs: "all",
                sessionSampleRate: 100,
                service: "box-website",
                env: "production",
            });

            if (userData) {
                datadogRum.setUser({
                    id: userData.id,
                    email: userData.email,
                    name: userData.name,
                    paymentStatus: userData?.payment_status,
                    submittedSurvey: userData?.submitted_survey,
                    survey_type_taken: userData?.survey_type_taken,
                });
            }
        };

        setupDatadog();
    }, [userData]);

    return null;
}
